import { render, staticRenderFns } from "./AppUploadButton.vue?vue&type=template&id=220641ec&scoped=true&"
import script from "./AppUploadButton.vue?vue&type=script&lang=js&"
export * from "./AppUploadButton.vue?vue&type=script&lang=js&"
import style0 from "./AppUploadButton.vue?vue&type=style&index=0&id=220641ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220641ec",
  null
  
)

export default component.exports